/**
 * Finds the key of the first element predicate that returns truthy.
 *
 * @example
 * findKey({foo: 0, bar: 1}, value => value === 1);
 * // => 'bar'
 *
 * @function findKey
 * @param {Object} object The object to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @return {*} Returns the key of the first matched element, otherwise `undefined`.
 */
export default function findKey(object, predicate) {
	if (!object) return;

	const result = Object.entries(object).find(([key, value]) => predicate(value, key));
	if (result) {
		const [key] = result;
		return key;
	}
}
